import(/* webpackMode: "eager" */ "/app/src/app/settings/page.tsx");
